export default {
  setCriterios({ commit, dispatch }, criterios) {
    commit('SET_CRITERIOS', criterios);
    dispatch('validarCriterios');
  },
  updateCriterio({ commit, dispatch }, { updatedCriterio }) {
    commit('UPDATE_CRITERIO', { updatedCriterio });
    dispatch('validarCriterios');
  },
  addCriterio({ commit, dispatch }, { newCriterio }) {
    commit('ADD_CRITERIO', newCriterio);
    dispatch('validarCriterios');
  },
  deleteCriterio({ commit, dispatch }, { deleteCriterio }){
    commit('DELETE_CRITERIO', deleteCriterio);
    dispatch('validarCriterios');
  },
  removeCriterio({ commit, dispatch }, index) {
    commit('REMOVE_CRITERIO', index);
    dispatch('validarCriterios');
  },
  validarCriterios({ commit, state }) {
    let criterios = state.criterios;
    let erros = [];

    criterios.forEach((criterio, index) => {
      let camposFaltantes = [];

      if (!criterio.operadorLogico) {
        camposFaltantes.push('operadorLogico');
      }
      if (!criterio.tipoCriterio) {
        camposFaltantes.push('tipoCriterio');
      }
      if (!criterio.operadorRelacional) {
        camposFaltantes.push('operadorRelacional');
      }

      if (criterio.tipoCriterio === "ServicoCalibracao") {
        if (criterio.servicoCalibracao && (!criterio.servicoCalibracao.id || !criterio.servicoCalibracao.codigo)) {
          camposFaltantes.push('servicoCalibracao.id', 'servicoCalibracao.codigo');
        }
      }

      if (criterio.tipoCriterio === "TipoCalibracao") {
        if (!criterio.tipoCalibracaoId && !criterio.tipoCalibracao.id) {
          camposFaltantes.push('tipoCalibracao.id');
        }
      }

      if (criterio.tipoCriterio === "TipoContrato") {
        if (!criterio.tipoContrato) {
          camposFaltantes.push('tipoContrato');
        }
      }
      
      if (criterio.tipoCriterio === "ServicoManutencao") {
        if ((!criterio.servicoManutencao && !criterio.servicoManutencao.id ) || !criterio.servicoManutencaoId) {
          camposFaltantes.push('servicoManutencao.id', 'servicoManutencaoId');
        }
      }

      if (criterio.tipoCriterio === "Item") {
        if (!(criterio.item && criterio.item.id) || !criterio.itemId) {
          camposFaltantes.push('item.id', 'itemId');
        }
      }

      if (criterio.tipoCriterio === "LocalExecucao") {
        if (!(criterio.localExecucao && criterio.localExecucao.id) || !criterio.localExecucaoId) {
          camposFaltantes.push('localExecucao.id', 'localExecucaoId');
        }
      }

      if (criterio.tipoCriterio === "ParticipanteConta") {
        if (!(criterio.participanteConta && criterio.participanteConta.id) || !criterio.participanteContaId) {
          camposFaltantes.push('participanteConta.id');
        }
      }

      if (criterio.tipoCriterio === "ValorTotalOrcamento") {
        if (!criterio.valorTotalOrcamento) {
          camposFaltantes.push('valorTotalOrcamento');
        }
      }

      if (criterio.tipoCriterio === "TipoOrcamento") {
        if (!criterio.tipoOrcamento) {
          camposFaltantes.push('tipoOrcamento');
        }
      }

      if (criterio.tipoCriterio === "TipoInstrumento") {
        if (!(criterio.tipoInstrumento && criterio.tipoInstrumento.id) || !criterio.tipoInstrumentoId) {
          camposFaltantes.push('tipoInstrumento.id', 'tipoInstrumentoId');
        }
      }
      
      if (criterio.tipoCriterio === "CampoAdicionalInstrumento") {
        if ((!criterio.campoAdicionalInstrumento && !criterio.campoAdicionalInstrumento.id || !criterio.campoAdicionalInstrumentoId) && !criterio.valor) {
          camposFaltantes.push('campoAdicionalInstrumento.id', 'campoAdicionalInstrumentoId', 'valor');
        }
      }

      if (criterio.tipoCriterio === "RequisitoParticipante") {
        if ((!criterio.campoAdicionalParticipante && !criterio.valor)) {
          camposFaltantes.push('campoAdicionalInstrumento.id', 'campoAdicionalInstrumentoId', 'valor');
        }
      }

      if (camposFaltantes.length > 0) {
        erros.push({
          item: index + 1,
          mensagem: `Campos obrigatórios ausentes no critério ${index + 1}: ${camposFaltantes.join(', ')}`
        });
      }
    });

    commit('SET_ERRORS', erros);
  }
}